import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React from 'react';
import CategoryBanner from '../../../components/organisms/categoryBanner/CategoryBanner';

const CategoryBannerTastic = ({ data, context }) => {
  if (!data) return null;
  const locale = context.locale === 'en_AU@AUD' ? 'AU' : 'NZ';

  if (!data[`show${locale}`]) return null;

  return <CategoryBanner {...data} />;
};

CategoryBannerTastic.propTypes = {
  data: PropTypes.object.isRequired,
};

export default tastify({
  translate: true,
  connect: { context: true },
})(CategoryBannerTastic);
